export default "__VITE_ASSET__1b76a73b__"